import { GridSortModel } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PatientScreenerAnswerControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  isPublicView?: boolean;
  gridSorting?: GridSortModel;
  appointmentUuid?: string;
  type: string;
  patientId?: string;
  xTENANTID?: string;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useGetAllScreeningListPrefill = ({
  pagination,
  isPublicView,
  gridSorting,
  appointmentUuid,
  type,
  patientId,
  xTENANTID,
}: Props): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;

  return useQuery({
    queryKey: [
      "encounter-all=screening-list",
      type,
      pagination,
      gridSorting,
      patientId,
      appointmentUuid,
      xTENANTID,
    ],
    enabled: !!type,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new PatientScreenerAnswerControllerApi(
        isPublicView ? undefined : getConfigObject()
      )
        .getPatientScreenersByType(
          type,
          pageIndex, //page
          pagination.pageSize, //size
          sortBy,
          sortDirect, // sortDirection
          patientId,
          appointmentUuid,
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
